class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartMainSummary extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('[data-ref="toggleSummary"]').forEach((button) => {
      button.addEventListener('click', this.toggleSummary.bind(this))
    });
  }

  toggleSummary() {
    this.classList.toggle('cart-main-summary--collapsed');
  }
}

customElements.define('cart-main-summary', CartMainSummary);

class CartItems extends HTMLElement {
  constructor() {
    super();

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    this.deliveryOptions = this.querySelector('[data-ref="deliveryOptions"]');

    if (this.deliveryOptions) {
      const shippingCalcObserver = new MutationObserver((mutations) => {
        this.updateTotals();
      });

      shippingCalcObserver.observe(this.deliveryOptions, {
        subtree: true,
        childList: true
      });
    }
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'product-form') {
        return
      }
      if (event.source === 'cart-items') {
        this.onCartDrawerUpdate();
      } else {
        this.onCartUpdate();
      }
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const sourceQty = html.querySelector('.js-contents');
        this.innerHTML = sourceQty.innerHTML;
        this.updateTotals();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  onCartDrawerUpdate() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const sourceQty = html.querySelector('.cart-main');
        this.innerHTML = sourceQty.innerHTML;
        this.updateTotals();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateTotals() {
    setTimeout(() => {
      const shippingElem = document.querySelector('.cbb-shipping-rates-calculator-shipping-subtotal .money');
      const totalElem = document.querySelector('.cbb-shipping-rates-calculator-cart-total .money');
      const deliveryEstimate = document.querySelector('[data-ref="deliveryEstimate"]');
      const grandTotal = document.querySelector('[data-ref="grandTotal"]');

      if (shippingElem && totalElem && grandTotal && deliveryEstimate) {
        const shippingCost = (shippingElem.textContent);
        const totalCost = (totalElem.textContent);

        grandTotal.textContent = totalCost;
        deliveryEstimate.textContent = shippingCost;
      }
    }, 1500);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: 'main-cart-footer',
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    let sectionsToRender = this.getSectionsToRender().map((section) => section.section)

    sectionsToRender = sectionsToRender.concat(this.getIconsToRender().map((section) => section.id))

    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToRender,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('cart-main--empty', parsedState.item_count === 0);

        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('cart-main--empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('cart-main--empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.getIconsToRender().forEach((section) => {
          const sectionElementsToReplace = document.querySelectorAll(section.selector);

          sectionElementsToReplace.forEach((sectionElementToReplace) => {
            if (parsedState.item_count === 0) {
              sectionElementToReplace.style.display = 'none';
            } else {
              sectionElementToReplace.style.display = 'flex';
            }
            sectionElementToReplace.innerHTML = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html').querySelector('.shopify-section').innerHTML;
          })
        });

        document.querySelectorAll('[data-ref="closeSideCart"]').forEach((button) => {
          button.addEventListener('click', () => {
            cartDrawerWrapper.classList.remove('is-active');
            document.body.classList.remove('drawer-open');
          });
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;

        let message = '';

        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }

        this.updateLiveRegions(line, message);
        this.updateTotals();

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });

      });
  }

  getIconsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        selector: '.cart-icon-bubble',
      }
    ];
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (message.indexOf("You can't add more") > -1) {
      message = "All available items are in your cart already";
    }

    if (lineItemError) {
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      lineItemError.classList.remove('hidden');

      setTimeout(() => {
        lineItemError.classList.add('hidden');
      }, 3000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const innerContent = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!innerContent) {

    }
    return innerContent.innerHTML
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);
